<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header *ngIf="contentHeader" [contentHeader]="contentHeader"></app-content-header>
    <section class="row">
      <div class="col-md-3 mb-2 mb-md-0" *ngIf="_utilService.isDesktop">
        <ul class="nav nav-pills flex-column nav-left mb-0">
          <li class="nav-item mb-1">
            <a [class]="'nav-link d-flex ' + (active_table === 'masterdata' ? 'active' : '')" (click)="active_table = 'masterdata'">
              <i [data-feather]="'user'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "MASTERDATA" | translate }}</span>
            </a>
          </li>
          <li class="nav-item mb-1">
            <a [class]="'nav-link d-flex ' + (active_table === 'addresses' ? 'active' : '')" (click)="active_table = 'addresses'">
              <i [data-feather]="'map-pin'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "ADDRESSES" | translate }}</span>
            </a>
          </li>
          <li class="nav-item mb-1">
            <a [class]="'nav-link d-flex ' + (active_table === 'informations' ? 'active' : '')" (click)="active_table = 'informations'">
              <i [data-feather]="'info'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "INFORMATIONS" | translate }}</span>
            </a>
          </li>
          <li class="nav-item mb-1">
            <a [class]="'nav-link d-flex ' + (active_table === 'change_password' ? 'active' : '')" (click)="active_table = 'change_password'">
              <i [data-feather]="'lock'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "CHANGE_PASSWORD" | translate }}</span>
            </a>
          </li>
          <li class="nav-item mb-1" *ngIf="currentUser">
            <a [class]="'nav-link d-flex ' + (active_table === 'id_document' ? 'active' : '')" (click)="active_table = 'id_document'">
              <i [data-feather]="'user'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "ID_DOCUMENTS" | translate }}</span>
            </a>
          </li>
        </ul>
      </div>

      <div class="col-12" *ngIf="_utilService.isMobile">
        <div ngbDropdown>
          <button ngbDropdownToggle type="button" class="btn btn-outline-primary mb-1 w-100">{{ active_table.toUpperCase() | translate }}</button>
          <div ngbDropdownMenu class="w-100">
            <ul class="nav nav-pills flex-column nav-left mb-0">
              <li class="nav-item" ngbDropdownItem>
                <a [class]="'nav-link d-flex ' + (active_table === 'masterdata' ? 'active' : '')" (click)="active_table = 'masterdata'">
                  <i [data-feather]="'user'" class="font-medium-3 mr-1"></i>
                  <span class="font-weight-bold">{{ "MASTERDATA" | translate }}</span>
                </a>
              </li>
              <li class="nav-item" ngbDropdownItem>
                <a [class]="'nav-link d-flex ' + (active_table === 'addresses' ? 'active' : '')" (click)="active_table = 'addresses'">
                  <i [data-feather]="'map-pin'" class="font-medium-3 mr-1"></i>
                  <span class="font-weight-bold">{{ "ADDRESSES" | translate }}</span>
                </a>
              </li>
              <li class="nav-item" ngbDropdownItem>
                <a [class]="'nav-link d-flex ' + (active_table === 'informations' ? 'active' : '')" (click)="active_table = 'informations'">
                  <i [data-feather]="'info'" class="font-medium-3 mr-1"></i>
                  <span class="font-weight-bold">{{ "INFORMATIONS" | translate }}</span>
                </a>
              </li>
              <li class="nav-item" ngbDropdownItem>
                <a [class]="'nav-link d-flex ' + (active_table === 'change_password' ? 'active' : '')" (click)="active_table = 'change_password'">
                  <i [data-feather]="'lock'" class="font-medium-3 mr-1"></i>
                  <span class="font-weight-bold">{{ "CHANGE_PASSWORD" | translate }}</span>
                </a>
              </li>
              <li class="nav-item" *ngIf="currentUser" ngbDropdownItem>
                <a [class]="'nav-link d-flex ' + (active_table === 'id_document' ? 'active' : '')" (click)="active_table = 'id_document'">
                  <i [data-feather]="'user'" class="font-medium-3 mr-1"></i>
                  <span class="font-weight-bold">{{ "ID_DOCUMENTS" | translate }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-9" *ngIf="currentUser">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title" *ngIf="active_table === 'masterdata'">{{ "MASTERDATA" | translate }}</h3>
            <h3 class="card-title" *ngIf="active_table === 'addresses'">{{ "RESIDENCE_ADDRESS" | translate }}</h3>
            <h3 class="card-title" *ngIf="active_table === 'informations'">{{ "PRIVATE_DATA" | translate }}</h3>
            <h3 class="card-title" *ngIf="active_table === 'contract'">{{ "CONTRACT" | translate }}</h3>
            <h3 class="card-title" *ngIf="active_table === 'emergency_contact'">{{ "EMERGENCY_CONTACT" | translate }}</h3>
            <h3 class="card-title" *ngIf="active_table === 'id_document'">{{ "ID_DOCUMENT" | translate }}</h3>
            <h3 class="card-title" *ngIf="active_table === 'socials'">{{ "SOCIAL_LINKS" | translate }}</h3>
            <h3 class="card-title" *ngIf="active_table === 'change_password'">{{ "CHANGE_PASSWORD" | translate }}</h3>
          </div>
          <!-- masterdata -->
          <div class="card-body" [formGroup]="formGroup" *ngIf="active_table === 'masterdata'">
            <div class="row">
              <div [ngClass.xl]="'col-12 form-group media'" [ngClass.sm]="'d-flex flex-column'">
                <a href="javascript:void(0);" (click)="file.click()" [ngClass.xl]="'mr-25'" [ngClass.sm]="'text-center'">
                  <img *ngIf="avatarImage" [src]="avatarImage" class="rounded mr-50 cover" alt="profile image" height="150" width="150" />
                  <img *ngIf="!avatarImage" src="/src/assets/images/placeholder-avatar.png" class="rounded mr-50" alt="profile image" height="150" width="150" />
                </a>
                <!-- upload and reset button -->
                <div [ngClass.xl]="'media-body mt-75 ml-1 pt-2'" [ngClass.sm]="'media-body col-12'">
                  <button (click)="file.click()" type="button" class="btn btn-md btn-primary" [ngClass.xl]="'mb-75 mr-75'" [ngClass.sm]="'my-1'" rippleEffect>{{ "INSERT.UPLOAD_FILE" | translate }}</button>
                  <input type="file" #file id="account-upload" hidden accept="image/*" (change)="handlerChangeFileInput($event, 'avatar')" />
                  <p [ngClass.sm]="'text-center'">{{ "MESSAGES.AVATAR_UPLOAD_INFO" | translate }}</p>
                </div>
                <!--/ upload and reset button -->
              </div>
              <div class="form-group col-md-5 col-12">
                <label for="firstname">{{ "FIRSTNAME" | translate }}</label>
                <input type="text" class="form-control" id="firstname" [value]="currentUser.firstname" readonly />
              </div>
              <div class="form-group col-md-5 col-12">
                <label for="lastname">{{ "LASTNAME" | translate }}</label>
                <input type="text" class="form-control" id="lastname" [value]="currentUser.lastname" readonly />
              </div>

              <div class="form-group col-md-2 col-12">
                <label for="sex">{{ "GENDER" | translate }}</label>
                <select name="sex" id="sex" class="form-control {{ fieldHasErrors('sex') ? 'is-invalid' : '' }}" formControlName="sex">
                  <option value="m">{{ "MALE" | translate }}</option>
                  <option value="f">{{ "FEMALE" | translate }}</option>
                  <option value="o">{{ "OTHER" | translate }}</option>
                </select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.sex.errors?.required">{{ "ERRRORS.INSERT_SEX" | translate }}</div>
              </div>
              <div class="form-group col-md-4 col-12">
                <label for="birthday">{{ "BIRTHDAY" | translate }}</label>
                <input type="date" id="birthday" [max]="min_birthdate" class="form-control {{ fieldHasErrors('birthday') ? 'is-invalid' : '' }}" formControlName="birthday" />
              </div>
              <div class="form-group col-md-4 col-12" *ngIf="hasCapability('edit_others_email')">
                <label for="email">{{ "USER_OFFICE_EMAIL" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="email" class="form-control {{ fieldHasErrors('email') ? 'is-invalid' : '' }}" (change)="handlerChangeOfficeEmail($event)" formControlName="email" />
                <div class="invalid-feedback" *ngIf="formGroup.controls.email.errors?.required">{{ "ERRORS.INSERT_OFFICE_EMAIL" | translate }}</div>
              </div>
              <div class="form-group col-md-4 col-12" *ngIf="!hasCapability('edit_others_email')">
                <label for="email">{{ "USER_OFFICE_EMAIL" | translate }}</label>
                <input type="text" class="form-control" [value]="currentUser.email" readonly />
              </div>
            </div>
          </div>
          <!-- addresses -->
          <div class="card-body" *ngIf="active_table === 'addresses'">
            <div class="row" [formGroup]="addressResidence_FormGroup">
              <div class="form-group col-md-8 col-12">
                <label for="address_street">{{ "ADDRESS_STREET" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  type="text"
                  id="address_street"
                  [placeholder]="'ADDRESS_STREET_PLACEHOLDER' | translate"
                  class="form-control {{ addressResidence_FormGroup.controls.street.errors ? 'is-invalid' : '' }}"
                  formControlName="street"
                  (change)="isCopingResidence = false"
                />
                <div class="invalid-feedback" *ngIf="addressResidence_FormGroup.controls.street.errors?.required">{{ "ERRORS.INSERT_ADDRESS" | translate }}</div>
              </div>
              <div class="col-xl-4 col-md-6 col-12 form-group" *ngIf="addressResidence_FormGroup.value.external">
                <label for="country">{{ "COUNTRY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="country"
                  [items]="nationsWithCodes"
                  bindLabel="name"
                  bindValue="code"
                  [clearable]="false"
                  (change)="isCopingResidence = false"
                  formControlName="country"
                  [ngClass]="addressResidence_FormGroup.controls.country.errors ? 'is-invalid' : ''"
                ></ng-select>
              </div>
              <div class="form-group col-md-4 col-12" *ngIf="!addressResidence_FormGroup.value.external">
                <label for="address_residence_zipcode">{{ "ADDRESS_ZIPCODE" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  type="text"
                  id="address_residence_zipcode"
                  [placeholder]="'ADDRESS_ZIPCODE_PLACEHOLDER' | translate"
                  class="form-control"
                  formControlName="zipcode"
                  [class]="'form-control ' + (addressResidence_FormGroup.controls.zipcode.errors ? 'is-invalid' : '')"
                  pattern="[0-9]+"
                />
                <div class="invalid-feedback" *ngIf="addressResidence_FormGroup.controls.zipcode.errors?.required">{{ "ADDRESS_ZIPCODE_REQUIRED" | translate }}</div>
              </div>
              <div class="form-group col-md-6 col-12" *ngIf="!addressResidence_FormGroup.value.external">
                <label for="address_residence_city">{{ "CITY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="id"
                  bindLabel="nice_name"
                  id="address_residence_city"
                  [items]="_citiesService.list"
                  formControlName="city_id"
                  [ngClass]="addressResidence_FormGroup.controls.city_id.errors ? 'is-invalid' : ''"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  (change)="setAutoProvince('Residence'); isCopingResidence = false"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="addressResidence_FormGroup.controls.city_id.errors?.required">{{ "ADDRESS_CITY_REQUIRED" | translate }}</div>
              </div>
              <div class="form-group col-md-6 col-12 mb-0" *ngIf="!addressResidence_FormGroup.value.external">
                <label for="address_residence_province">{{ "ADDRESS_PROVINCE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="id"
                  bindLabel="nice_name"
                  id="address_residence_province"
                  formControlName="province_id"
                  [class]="addressResidence_FormGroup.controls.province_id.errors ? 'is-invalid' : ''"
                  [items]="_citiesService.list"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  (change)="isCopingResidence = false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="addressResidence_FormGroup.controls.province_id.errors?.required">{{ "ADDRESS_PROVINCE_REQUIRED" | translate }}</div>
              </div>
              <div class="form-group col-md-6 col-12 d-flex align-items-center">
                <small class="mr-1">{{ "EXTERNAL_ADDRESS_QUESTION" | translate }}</small>
                <div class="custom-control custom-control-primary custom-switch">
                  <input type="checkbox" class="custom-control-input" id="externalResidence" formControlName="external" (change)="manageExternalSiteResidence()" />
                  <label class="custom-control-label" for="externalResidence"> </label>
                </div>
              </div>
            </div>
            <div class="row mt-3 border-top pt-2" [formGroup]="addressBilling_FormGroup" *ngIf="!isAnInternUser">
              <h4 class="col-md-6 col-12 mb-1">{{ "BILLING_ADDRESS" | translate }}</h4>
              <div
                *ngIf="
                  (addressResidence_FormGroup.value.street && addressResidence_FormGroup.value.zipcode && addressResidence_FormGroup.value.city && addressResidence_FormGroup.value.province) ||
                  (addressResidence_FormGroup.value.street && addressResidence_FormGroup.value.external)
                "
                class="form-group col-md-6 col-12 pr-0 d-flex justify-content-end"
              >
                <small class="mr-1 mt-025">{{ "ADDRESS_SAME_RESIDENCE" | translate }}</small>
                <div class="custom-control custom-control-primary custom-switch">
                  <input type="checkbox" class="custom-control-input" [(ngModel)]="isCopingResidence" [ngModelOptions]="{ standalone: true }" id="copyResidence" (click)="copyResidence()" />
                  <label class="custom-control-label" for="copyResidence"> </label>
                </div>
              </div>
              <div class="form-group col-md-8 col-12">
                <label for="address_living_street">{{ "ADDRESS_STREET" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  type="text"
                  id="address_living_street"
                  [placeholder]="'ADDRESS_STREET_PLACEHOLDER' | translate"
                  (change)="isCopingResidence = false"
                  formControlName="street"
                  [class]="'form-control ' + (addressBilling_FormGroup.controls.street.errors ? 'is-invalid' : '')"
                />
                <div class="invalid-feedback" *ngIf="addressBilling_FormGroup.controls.street.errors?.required">{{ "ADDRESS_STREET_REQUIRED" | translate }}</div>
              </div>
              <div class="col-xl-4 col-md-6 col-12 form-group" *ngIf="addressBilling_FormGroup.value.external">
                <label for="country">{{ "COUNTRY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="country"
                  [items]="nationsWithCodes"
                  bindLabel="name"
                  bindValue="code"
                  (change)="isCopingResidence = false"
                  [clearable]="false"
                  formControlName="country"
                  [ngClass]="addressBilling_FormGroup.controls.country.errors ? 'is-invalid' : ''"
                ></ng-select>
              </div>
              <div class="form-group col-md-4 col-12">
                <label for="address_living_zipcode">{{ "ADDRESS_ZIPCODE" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  type="text"
                  id="address_living_zipcode"
                  [placeholder]="'ADDRESS_ZIPCODE_PLACEHOLDER' | translate"
                  class="form-control"
                  (change)="isCopingResidence = false"
                  formControlName="zipcode"
                  [class]="'form-control ' + (addressBilling_FormGroup.controls.zipcode.errors ? 'is-invalid' : '')"
                  pattern="[0-9]+"
                />
                <div class="invalid-feedback" *ngIf="addressBilling_FormGroup.controls.zipcode.errors?.required">{{ "ADDRESS_ZIPCODE_REQUIRED" | translate }}</div>
              </div>
              <div class="form-group col-md-6 col-12">
                <label for="address_living_city">{{ "CITY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="id"
                  bindLabel="nice_name"
                  id="address_living_city"
                  [items]="_citiesService.list"
                  formControlName="city_id"
                  [class]="addressBilling_FormGroup.controls.city_id.errors ? 'is-invalid' : ''"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  (change)="setAutoProvince('Billing'); isCopingResidence = false"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="addressBilling_FormGroup.controls.city_id.errors?.required">{{ "ADDRESS_CITY_REQUIRED" | translate }}</div>
              </div>
              <div class="form-group col-md-6 col-12">
                <label for="address_living_province">{{ "ADDRESS_PROVINCE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="id"
                  bindLabel="nice_name"
                  id="address_living_province"
                  formControlName="province_id"
                  [class]="addressBilling_FormGroup.controls.province_id.errors ? 'is-invalid' : ''"
                  [items]="_citiesService.list"
                  [closeOnSelect]="true"
                  (change)="isCopingResidence = false"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="addressBilling_FormGroup.controls.province_id.errors?.required">{{ "ADDRESS_PROVINCE_REQUIRED" | translate }}</div>
              </div>
              <div class="form-group col-md-6 col-12 d-flex align-items-center">
                <small class="mr-1">{{ "EXTERNAL_ADDRESS_QUESTION" | translate }}</small>
                <div class="custom-control custom-control-primary custom-switch">
                  <input type="checkbox" class="custom-control-input" id="customSwitchExternalLiving" formControlName="external" (change)="manageExternalSiteLiving()" />
                  <label class="custom-control-label" for="customSwitchExternalLiving"> </label>
                </div>
              </div>
            </div>
          </div>
          <!-- change password -->
          <div class="card-body" [formGroup]="pwdFormGroup" *ngIf="active_table === 'change_password'">
            <div class="row">
              <div class="form-group col-md-6 col-12">
                <label for="old-password">{{ "OLD_PASSWORD" | translate }}</label>
                <div class="input-group input-group-merge form-password-toggle">
                  <input
                    [type]="oldPasswordType ? 'text' : 'password'"
                    id="old-password"
                    autocomplete="current-password"
                    class="form-control"
                    formControlName="current_password"
                    aria-describedby="old-password"
                    tabindex="1"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text cursor-pointer">
                      <i class="feather font-small-4" [ngClass]="{ 'icon-eye-off': oldPasswordType, 'icon-eye': !oldPasswordType }" (click)="togglePasswordTextType('old')"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12"></div>
              <div class="form-group col-md-6 col-12">
                <label for="new-password">{{ "NEW_PASSWORD" | translate }}</label>
                <div class="input-group input-group-merge form-password-toggle">
                  <input
                    [type]="newPasswordType ? 'text' : 'password'"
                    id="new-password"
                    autocomplete="new-password"
                    class="form-control"
                    tabindex="2"
                    aria-describedby="new_password"
                    formControlName="new_password"
                    [ngClass]="pwdFormGroup.hasError('weakPassword') ? 'is-invalid' : ''"
                    (change)="pwdFormGroup.hasError('weakPassword') ? removePwdErrors('weakPassword') : true"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text cursor-pointer">
                      <i class="feather font-small-4" [ngClass]="{ 'icon-eye-off': newPasswordType, 'icon-eye': !newPasswordType }" (click)="togglePasswordTextType('new')"></i>
                    </span>
                  </div>
                </div>
                <p class="text-danger" *ngIf="pwdFormGroup.hasError('weakPassword')">{{ "PASSWORD_WEAK" | translate }}</p>
              </div>
              <div class="form-group col-md-6 col-12">
                <label for="confirm-password">{{ "CONFIRM_PASSWORD" | translate }}</label>
                <div class="input-group input-group-merge form-password-toggle">
                  <input
                    [type]="confirmPasswordType ? 'text' : 'password'"
                    id="confirm-password"
                    autocomplete="new-password"
                    class="form-control"
                    tabindex="3"
                    aria-describedby="confirm-password"
                    formControlName="confirm_password"
                    (change)="pwdFormGroup.hasError('notSamePwd') ? removePwdErrors('notSamePwd') : true"
                    [ngClass]="pwdFormGroup.hasError('notSamePwd') ? 'is-invalid' : ''"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text cursor-pointer">
                      <i class="feather font-small-4" [ngClass]="{ 'icon-eye-off': confirmPasswordType, 'icon-eye': !confirmPasswordType }" (click)="togglePasswordTextType('confirm')"></i>
                    </span>
                  </div>
                </div>
                <p class="text-danger" *ngIf="pwdFormGroup.hasError('notSamePwd')">{{ "PASSWORD_MISMATCH" | translate }}</p>
              </div>
            </div>
          </div>
          <!-- informations -->
          <div class="card-body" [formGroup]="formGroup" *ngIf="active_table === 'informations'">
            <div class="row">
              <div class="form-group col-md-4 col-12">
                <label for="birth_place">{{ "BIRTH_PLACE" | translate }}</label>
                <ng-select
                  bindValue="id"
                  bindLabel="nice_name"
                  id="birth_place"
                  class="{{ fieldHasErrors('birth_place') ? 'is-invalid' : '' }}"
                  formControlName="birth_place"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="_citiesService.list"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.birth_place.errors?.required">{{ "ADDRESS_PROVINCE_REQUIRED" | translate }}</div>
              </div>
              <div class="form-group col-md-4 col-12">
                <label for="working_city">{{ "WORKING_CITY" | translate }}</label>
                <ng-select
                  bindValue="id"
                  bindLabel="nice_name"
                  id="working_city"
                  [items]="_citiesService.list"
                  class="{{ fieldHasErrors('working_city') ? 'is-invalid' : '' }}"
                  formControlName="working_city"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                ></ng-select>
              </div>
              <div class="form-group col-md-4 col-12">
                <label for="site">{{ "JOB_SITE" | translate }}</label>
                <ng-select
                  bindValue="id"
                  bindLabel="name"
                  id="site"
                  class="{{ fieldHasErrors('site') ? 'is-invalid' : '' }}"
                  formControlName="site"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="_jobSiteService.list"
                ></ng-select>
              </div>
              <div class="form-group col-md-4 col-12">
                <label for="phone">{{ "PRIVATE_PHONE" | translate }}<sup class="text-danger">*</sup></label>
                <input type="tel" id="phone" maxlength="15" class="form-control {{ fieldHasErrors('phone') ? 'is-invalid' : '' }}" formControlName="phone" />
              </div>
              <div class="form-group col-md-4 col-12">
                <label for="private_email">{{ "PRIVATE_EMAIL" | translate }}<sup class="text-danger">*</sup></label>
                <input type="email" id="private_email" class="form-control {{ fieldHasErrors('private_email') ? 'is-invalid' : '' }}" formControlName="private_email" />
              </div>
              <div class="form-group col-md-4 col-12">
                <label for="civil_status">{{ "CIVIL_STATUS" | translate }}</label>
                <ng-select
                  bindValue="name"
                  bindLabel="name"
                  id="civil_status"
                  class="{{ fieldHasErrors('civil_status') ? 'is-invalid' : '' }}"
                  formControlName="civil_status"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="_userService.civil_status"
                ></ng-select>
              </div>
              <div class="form-group col-md-6 col-12" *ngIf="currentUser.type_code !== 'external'">
                <label for="IBAN">{{ "IBAN" | translate }}</label>
                <input type="text" id="IBAN" class="form-control {{ fieldHasErrors('IBAN') ? 'is-invalid' : '' }}" formControlName="IBAN" />
              </div>
            </div>
          </div>
          <!-- id_document -->
          <div class="card-body" [formGroup]="formGroup" *ngIf="active_table === 'id_document'">
            <div class="row">
              <div class="form-group col-md-6 col-12">
                <label for="type_nationality">{{ "TYPE_NATIONALITY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select [clearable]="false" (change)="setCountry()" id="type_nationality" [(ngModel)]="type_nationality" [ngModelOptions]="{ standalone: true }">
                  <ng-option value="Italiana">{{ "ITALIAN" | translate }}</ng-option>
                  <ng-option value="UE">UE</ng-option>
                  <ng-option value="Extra Ue">Extra UE</ng-option>
                </ng-select>
              </div>
              <div class="form-group col-md-6 col-12">
                <label for="nationality">{{ "NATIONALITY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select id="nationality" class="{{ fieldHasErrors('nationality') ? 'is-invalid' : '' }}" formControlName="nationality">
                  <ng-option *ngFor="let nationality of nationalities_list" [value]="nationality">{{ nationality }}</ng-option>
                </ng-select>
              </div>

              <div class="form-group col-md-6 col-12">
                <label for="document_type">{{ "DOCUMENT_TYPE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="value"
                  bindLabel="name"
                  id="document_type"
                  formControlName="document_type"
                  class="{{ fieldHasErrors('document_type') ? 'is-invalid' : '' }}"
                  [items]="document_id_types"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                ></ng-select>
              </div>
              <div class="form-group col-md-6 col-12">
                <label for="document_number">{{ "DOCUMENT_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  type="text"
                  id="document_number"
                  oninput="this.value = this.value.toUpperCase()"
                  class="form-control {{ fieldHasErrors('document_number') ? 'is-invalid' : '' }}"
                  formControlName="document_number"
                />
              </div>
              <div class="form-group col-md-6 col-12">
                <label for="document_valid_until">{{ "VALID_UNTIL" | translate }}<sup class="text-danger">*</sup></label>
                <input type="date" id="document_valid_until" class="form-control {{ fieldHasErrors('document_valid_until') ? 'is-invalid' : '' }}" formControlName="document_valid_until" />
              </div>
              <div class="col-md-6 col-12">
                <fieldset>
                  <label for="document_id">{{ "DOCUMENT_ID" | translate }}<sup class="text-danger">*</sup></label>
                  <div class="custom-file">
                    <input class="custom-file-input" type="file" lang="it" id="document_id" accept="application/pdf, image/jpg, image/png, image/jpeg" (change)="handlerChangeFileInput($event, 'document-id')" />
                    <label *ngIf="!fileNameDocumentId" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
                    <label *ngIf="fileNameDocumentId && fileNameDocumentId.length > 0" class="custom-file-label">{{ fileNameDocumentId }}</label>
                  </div>
                </fieldset>
              </div>
              <div class="col-md-6 col-12">
                <label>&nbsp;</label>
                <div *ngIf="currentUser.identity_document && currentUser.identity_document.document_url">
                  <button (click)="viewDocument(currentUser.identity_document.document_url)" class="btn btn-outline-secondary">{{ "VIEW_DOCUMENT" | translate }}</button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mt-4">
                <h4>{{ "FISCAL_CODE" | translate }}</h4>
              </div>
              <div class="form-group col-md-4 col-12">
                <label for="fiscalcode">{{ "FISCAL_CODE" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="fiscalcode" class="form-control {{ fieldHasErrors('fiscalcode') ? 'is-invalid' : '' }}" formControlName="fiscalcode" />
              </div>
              <div class="col-md-4 col-12">
                <fieldset>
                  <label>{{ "FISCAL_CODE" | translate }}<sup class="text-danger">*</sup></label>
                  <div class="custom-file">
                    <input class="custom-file-input" type="file" lang="it" id="file_fiscal_code" accept="application/pdf, image/jpg, image/png" (change)="handlerChangeFileInput($event, 'fiscal-code')" />
                    <label *ngIf="!fileNameFiscalCode" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
                    <label *ngIf="fileNameFiscalCode && fileNameFiscalCode.length > 0" class="custom-file-label">{{ fileNameFiscalCode }}</label>
                  </div>
                </fieldset>
              </div>
              <div class="col-md-4 col-12">
                <label>&nbsp;</label>
                <div *ngIf="currentUser.identity_document && currentUser.identity_document.fiscalcode_url">
                  <button (click)="viewDocument(currentUser.identity_document.fiscalcode_url)" class="btn btn-outline-secondary">{{ "VIEW_FISCAL_CODE_DOCUMENT" | translate }}</button>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="type_nationality === 'Extra Ue'">
              <div class="col-12 mt-4">
                <h4>{{ "RESIDENCE_PERMIT" | translate }}</h4>
              </div>
              <div class="form-group col-md-6 col-12">
                <label for="document_residence_permit_valid_until">{{ "VALID_UNTIL" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  type="date"
                  id="document_residence_permit_valid_until"
                  class="form-control {{ fieldHasErrors('document_residence_permit_valid_until') ? 'is-invalid' : '' }}"
                  formControlName="document_residence_permit_valid_until"
                />
              </div>
              <div class="form-group col-md-6 col-12">
                <label for="document_residence_permit_number">{{ "RESIDENCE_PERMIT_NUMBER" | translate }} <sup class="text-danger">*</sup></label>
                <input
                  type="text"
                  id="document_residence_permit_number"
                  class="form-control {{ fieldHasErrors('document_residence_permit_number') ? 'is-invalid' : '' }}"
                  formControlName="document_residence_permit_number"
                />
              </div>
              <div class="col-md-6 col-12">
                <fieldset>
                  <label>{{ "RESIDENCE_PERMIT" | translate }}<sup class="text-danger">*</sup></label>
                  <div class="custom-file">
                    <input class="custom-file-input" type="file" lang="it" id="file_residence_permit" accept="image/*,application/pdf" (change)="handlerChangeFileInput($event, 'residence-permit')" />
                    <label *ngIf="!fileNamePermit" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
                    <label *ngIf="fileNamePermit && fileNamePermit.length > 0" class="custom-file-label">{{ fileNamePermit }}</label>
                  </div>
                </fieldset>
              </div>
              <div class="col-md-4 col-12">
                <label>&nbsp;</label>
                <div *ngIf="currentUser.identity_document && currentUser.identity_document.residence_permit_url">
                  <button (click)="viewDocument(currentUser.identity_document.residence_permit_url)" class="btn btn-outline-secondary">{{ "VIEW_PERMIT_URL" | translate }}</button>
                </div>
              </div>
            </div>
          </div>
          <!-- footer -->
          <div class="card-footer d-flex align-items-end pt-2">
            <div class="flex-basis-100 text-right">
              <button
                type="submit"
                class="btn btn-primary"
                [disabled]="active_table === 'change_password' ? pwdFormGroup.value.new_password.length < 1 && pwdFormGroup.value.new_password !== pwdFormGroup.value.confirm_password : null"
                (click)="active_table === 'change_password' ? changePassword() : save()"
              >
                {{ "SAVE" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
